import React, { useState } from 'react';
import PropTypes from 'prop-types';
import FormBase from '../../../../common/FormBase';
import Form from './Form';
import { makeInitialState } from '../../../../../helpers/FormHelper';
import { MakeFields } from './validation/fields';
import { schema } from './validation/schema';

const ArrivedOtherProduct = ({ ...props }) => {
  const { mobile, motiveId, issueForm, typeId } = props;
  const [state, setState] = useState({});
  const [data, setData] = useState({});
  const [valid, setValid] = useState(false);
  const [validLength] = useState(9);
  const [showForm, setShowForm] = useState(true);

  const handleData = (data) => {
    setData(data);
  };

  const onState = (innerState) => {
    setState(innerState);
  };

  const handleValid = (validity) => {
    setValid(validity);
  };

  return (
    <React.Fragment>
      <FormBase
        pre={!showForm}
        issueForm={issueForm}
        mobile={mobile}
        title=""
        schema={schema}
        data={data}
        fields={MakeFields()}
        formName="ArrivedOtherProduct"
        makeInitialState={makeInitialState}
        onState={onState}
        motiveId={motiveId}
        typeId={typeId}
        validLength={validLength}
        onValid={handleValid}
        form={
          <Form
            issueForm={issueForm}
            mobile={mobile}
            state={state}
            onData={handleData}
            valid={valid}
            motiveId={motiveId}
            fields={MakeFields()}
            setShowForm={setShowForm}
          />
        }
      />
    </React.Fragment>
  );
};

ArrivedOtherProduct.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  issueForm: PropTypes.bool,
  typeId: PropTypes.string,
};

export default ArrivedOtherProduct;
